import { FC } from 'react';

import { Collapse } from 'antd';
import cs from 'classnames';

import { CollapseListItem } from 'types/commons';

import { ReactComponent as MinusIcon } from 'assets/icons/minus.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';

import styles from './styles.module.scss';

interface BenefitsAccordionProps {
  items: CollapseListItem[];
}

const BenefitsAccordion: FC<BenefitsAccordionProps> = ({ items }) => {
  return (
    <div className={styles.benefitsSection}>
      <Collapse
        accordion
        className={styles.benefitsCollapseContainer}
        defaultActiveKey={['1']}
        expandIcon={({ isActive }) =>
          isActive ? (
            <MinusIcon className={styles.iconMinus} />
          ) : (
            <PlusIcon className={styles.iconPlus} />
          )
        }
      >
        {items.map(({ key, label, content, className }) => (
          <Collapse.Panel
            key={key}
            header={
              <div className={cs(styles.header, styles[`header${className}`])}>
                <span className={cs(styles.icon, styles[`icon${className}`])} />
                <span>{label}</span>
              </div>
            }
            className={cs(styles.panel, styles[`panel${className}`])}
          >
            {content}
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default BenefitsAccordion;
